import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";

const EventGalleryApi = createApi({
    reducerPath: 'EventGalleryApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getEventGallariesList: builder.mutation({
            query: (details) => ({
                url: '/EventGallery/GetEventGallariesList',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEventGalleryDetails: builder.mutation({
            query: (details) => ({
                url: '/EventGallery/AddEventGalleryDetails',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteEventGallery: builder.mutation({
            query: (details) => ({
                url: '/EventGallery/DeleteEventGalleryDetailById',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getEventGalleryDetailById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/EventGallery/GetEventGalleryDetailById?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateEventGalleryDetails: builder.mutation({
            query: (details) => ({
                url: '/EventGallery/UpdateEventGalleryDetails',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getEventGalleryImages: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/EventGallery/GetEventGalleryImages?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteImageByeventGallaryId: builder.mutation({
            query: (details) => ({
                url: '/EventGallery/DeleteImageByeventGallaryId',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEventGalleryImage: builder.mutation({
            query: (details) => ({
                url: '/EventGallery/AddEventGalleryImage',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        
    }),

})

export const {
useGetEventGallariesListMutation,
useAddEventGalleryDetailsMutation,
useDeleteEventGalleryMutation,
useLazyGetEventGalleryDetailByIdQuery,
useUpdateEventGalleryDetailsMutation,
useLazyGetEventGalleryImagesQuery,
useDeleteImageByeventGallaryIdMutation,
useAddEventGalleryImageMutation
} = EventGalleryApi;

export default EventGalleryApi;